import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
} from "@mui/material";
import axios from "axios";
import API_BASE_URL from "../../../config/api";

const ReminderDialog = ({ showOnLoginOnly }) => {
  const [reminderOpen, setReminderOpen] = useState(false);
  const [reminderAppointments, setReminderAppointments] = useState([]);
  // const todayDate = moment().format("YYYY-MM-DD");

  useEffect(() => {
    // if reminderdialog has shown (true), then it would not show again
    if (showOnLoginOnly && localStorage.getItem("reminderShown") === "true") {
      return; // prevent showing dislog again
    }

    fetchReminderAppointments();
  }, []);

  const fetchReminderAppointments = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/admin/fetchReminderAppointments.php`);
      if (response.data.length > 0) {
        setReminderAppointments(response.data);
        setReminderOpen(true);

        // mark reminder as shown in localstorage
        if (showOnLoginOnly) {
          localStorage.setItem("reminderShown", "true");
        }
      }
    } catch (error) {
      console.error("Error fetching reminder appointments", error);
    }
  };

  return (
    <>
      {/* Reminder Dialog */}
      <Dialog open={reminderOpen} onClose={() => setReminderOpen(false)}>
        <DialogTitle>Today's Scheduled & Overdue Appointments</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper} sx={{ marginTop: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>ID</b>
                  </TableCell>
                  <TableCell>
                    <b>Name</b>
                  </TableCell>
                  <TableCell>
                    <b>Scheduled Date</b>
                  </TableCell>
                  <TableCell>
                    <b>Scheduled Time Slot</b>
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reminderAppointments.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No reminders
                    </TableCell>
                  </TableRow>
                ) : (
                  reminderAppointments.map((appointment) => (
                    <TableRow key={appointment.id}>
                      <TableCell>{appointment.id}</TableCell>
                      <TableCell>{appointment.name}</TableCell>
                      <TableCell>{appointment.scheduled_date}</TableCell>
                      <TableCell>{appointment.scheduled_timeslot}</TableCell>
                      <TableCell>
                        <Chip
                          label={
                            appointment.appointment_type === "Upcoming"
                              ? "Upcoming"
                              : "Overdue"
                          }
                          color={
                            appointment.appointment_type === "Upcoming"
                              ? "success"
                              : "error"
                          }
                          variant="outlined"
                        />
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setReminderOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReminderDialog;
